import { Request } from 'crono-fe-common/types/request';
import client from 'utils/clients/client';
import { ENDPOINTS } from '../../../config/endpoints';
import { GoogleSettings } from 'crono-fe-common/types/googleSettings';

export type GoogleVerifyIntegrationResult = {
  data: { isSuccess: boolean; data: GoogleSettings | null };
};

class GoogleService {
  private _alreadyRunningVerifyGoogleIntegrationCall: Promise<GoogleVerifyIntegrationResult> | null =
    null;

  public async verifyGoogleIntegration(
    email: string,
  ): Promise<GoogleVerifyIntegrationResult> {
    if (this._alreadyRunningVerifyGoogleIntegrationCall) {
      return await this._alreadyRunningVerifyGoogleIntegrationCall;
    } else {
      this._alreadyRunningVerifyGoogleIntegrationCall =
        this._verifyGoogleIntegration(email);
      try {
        const verifyResult =
          await this._alreadyRunningVerifyGoogleIntegrationCall;
        return verifyResult;
      } catch (e) {
        return {
          data: {
            isSuccess: false,
            data: null,
          },
        };
      } finally {
        this._alreadyRunningVerifyGoogleIntegrationCall = null;
      }
    }
  }

  private async _verifyGoogleIntegration(
    email: string,
  ): Promise<GoogleVerifyIntegrationResult> {
    const request: Request = {
      url: ENDPOINTS.google.verify,
      config: {
        method: 'POST',
        data: { email },
      },
    };

    const result = await client(request);
    return result as GoogleVerifyIntegrationResult;
  }
}

// I export a single instance of the service, so that all other files that import
// this file will always import the same instance
export default new GoogleService();
